import {
  Menu,
  MenuButton,
  MenuList,
  IconButton,
  Flex,
  Text,
  Box,
  Image,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  TabIndicator,
  Avatar,
  Badge,
  useDisclosure,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectUnReadMsSystemNum, selectUser, updateUnReadMsSystemNum } from "@/reducer/userslice";
import { RiNotification4Fill } from "@remixicon/react";

import noMessage from "@/assets/images/nomessage1.png";
import sysAvatar from "@/assets/images/sys_avatar.png";
import { MsSystem } from "@/types/mssystem";
import { format } from "date-fns";
import {
  useLazyGetMsSystemQuery,
  useReadMsSystemMutation,
} from "@/services/api/endpoints/mssystem";
import { useEffect, useState } from "react";
import { MsUser } from "@/types/msuser";
import { useLazyGetMsUserByToIdQuery } from "@/services/api/endpoints/msuser";
import PrivateLetterModal from "@/components/privateLetterModal";
import {
  useCreateFollowMutation,
  useDeleteFollowMutation,
  useLazyGetFansQuery,
  useLazyGetFollowsQuery,
} from "@/services/api/endpoints/follow";
import { Follow } from "@/types/follow";
import { ServerError } from "@/types/errors";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const MessageMenu = (props: Props) => {
  const { isOpen, onClose } = props;
  // const dispatch = useDispatch();
  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const userId = user.id;
  const prvLetterControl = useDisclosure();
  const toast = useToast();

  const [tabIndex, setTabIndex] = useState(0);
  const [currentLetterUserId, setCurrentLetterUserId] = useState<string>("");

  const [getMsSystem, { data: systemMsg }] = useLazyGetMsSystemQuery();
  const [readMsSystem] = useReadMsSystemMutation();
  const [getMsUserByToId, { data: privateLetter }] =
    useLazyGetMsUserByToIdQuery();
  const [getFollows, { data: followersList }] = useLazyGetFollowsQuery();
  const [getFans, { data: newFas }] = useLazyGetFansQuery();
  const [createFollow] = useCreateFollowMutation();
  const [deleteFollow] = useDeleteFollowMutation();

  // 未读系统消息数
  const unReadMsSystemNumn = useAppSelector(selectUnReadMsSystemNum);

  const handleChangeTab = (index: number) => {
    if (user && user.id) {
      setTabIndex(index);
    } else {
      toast({
        title: "请登录系统",
        position: "top",
        status: "error",
        duration: 1000,
      });
    }
  };

  const handleGoMessagesCenter = () => {
    if (user && user.id) {
      navigate("/messages"); // 切换到我的消息
    } else {
      toast({
        title: "请登录系统",
        position: "top",
        status: "error",
        duration: 1000,
      });
    }
  };
  useEffect(()=>{
    getMsSystem({
      user_id: userId,
      limit: 3,
    });
  },[unReadMsSystemNumn])
  // 组件挂载后获取初始数据
  useEffect(() => {
    if (isOpen) {
      if (tabIndex === 0) {
        getMsSystem({
          user_id: userId,
          limit: 3,
        });
      }
      if (tabIndex === 1) {
        getMsUserByToId({ user_id: userId });
        setTabIndex(1);
      }
      if (tabIndex === 2) {
        getFans(userId);
        getFollows(userId);
      }
    }
    return () => {};
  }, [tabIndex, isOpen]);

  const handleReadMsSystem = async (message: MsSystem) => {
    if(message.is_read){
      // toast({
      //   title: "暂无未读系统消息",
      //   position: "top",
      //   status: "error",
      //   duration: 1000,
      // });
      return;
    }
    console.log("111")
    const unreadNum = unReadMsSystemNumn-1;
    const res = await readMsSystem({ user_id: userId, message_id: message.id });
    if(res){
      dispatch(updateUnReadMsSystemNum(unreadNum));
    }
  };

  const handleAllReadMsSystem = () => {
    if (user && user.id) {
      systemMsg?.map(async (item) => {
        await readMsSystem({ user_id: userId, message_id: item.id });
      });
      dispatch(updateUnReadMsSystemNum(0));
    } else {
      toast({
        title: "请登录系统",
        position: "top",
        status: "error",
        duration: 1000,
      });
    }
  };

  const handleClickPrivateLetter = (form_id: string) => {
    setCurrentLetterUserId(form_id);
    prvLetterControl.onOpen();
  };

  // 回关
  const handleCreateFollow = async (follow: Follow) => {
    const followData = {
      id: follow.id,
      user_id: follow.user_id,
      followee_id: follow.followee_id,
      create_at: follow.create_at,
      update_at: follow.update_at,
      status: 0,
      permission: follow.permission,
      user: follow.user,
      contents: follow.contents,
    };
    await createFollow(followData)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
  };

  // 取消关注
  const handleCancelFollow = async (follow: Follow) => {
    const followData = {
      ...follow,
      status: 1,
    };
    await deleteFollow(followData)
      .unwrap()
      .catch((e) => {
        toast({
          title: (e as ServerError).message,
          position: "top",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      });
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        {/* <ModalOverlay /> */}
        <ModalContent
          // w="420px"
          p="0px"
          bg="#fff"
          w={"384px"}
          color="#333333"
          maxH="calc(100vh - 80px)"
          overflow={"auto"}
          sx={{
            position: "absolute",
            top: "0px",
            right: "20px",
          }}
        >
          {/* <ModalHeader color="#27314D" fontSize={"18px"}>
            永久删除会话
          </ModalHeader>
          <ModalCloseButton color={"#B9B9B9"} /> */}
          <ModalBody p="0">
            <Box>
              <Box pl="30px" pr="30px">
                <Tabs
                  position="relative"
                  isFitted
                  variant="unstyled"
                  index={tabIndex}
                  onChange={handleChangeTab}
                >
                  <TabList color="#8E94A9">
                    <Tab
                      fontSize={"14px"}
                      _selected={{ color: "#27314D", fontWeight: "bold" }}
                    >
                      <Text position={"relative"}>
                        系统消息
                        {unReadMsSystemNumn>0 && (
                          <Box
                            position="absolute"
                            top="0"
                            right="-15px"
                            height="14px"
                            width="14px"
                            bg={"#ff0000"}
                            color="#fff"
                            fontSize={"8px"}
                            textAlign="center"
                            lineHeight={"14px"}
                            borderRadius="50%"
                          >
                            {unReadMsSystemNumn}
                          </Box>
                        )}
                      </Text>
                    </Tab>
                    <Tab
                      fontSize={"14px"}
                      _selected={{ color: "#27314D", fontWeight: "bold" }}
                    >
                      私信
                    </Tab>
                    <Tab
                      fontSize={"14px"}
                      _selected={{ color: "#27314D", fontWeight: "bold" }}
                    >
                      新增关注
                    </Tab>
                  </TabList>
                  <TabIndicator
                    mt="-1.5px"
                    height="2px"
                    bg="#27314D"
                    borderRadius="1px"
                  />

                  <TabPanels>
                    {/* 系统消息 */}
                    <TabPanel pl="0" pr="0">
                      {!systemMsg?.length && (
                        <Flex
                          minH={"160px"}
                          flexDir={"column"}
                          justifyContent={"center"}
                          alignItems="center"
                        >
                          <Image src={noMessage} mb="14px" />
                          <Text fontSize={"14px"} color="#8E94A9">
                            没有未读的消息哦～
                          </Text>
                        </Flex>
                      )}

                      {systemMsg &&
                        systemMsg.length > 0 &&
                        systemMsg.map((item, index) => {
                          return (
                            <Flex
                              p="10px"
                              key={index}
                              justifyContent="space-between"
                              _hover={{
                                bg: "rgba(238, 241, 247, 0.5)",
                              }}
                              onClick={() => handleReadMsSystem(item)}
                            >
                              <Flex mr={"10px"} flex={1}>
                                <Avatar size="sm" mr="18px" src={sysAvatar} />
                                <Box>
                                  <Box>
                                    <Text
                                      display={"inline"}
                                      fontWeight="700"
                                      mr="10px"
                                      color={"#27314D"}
                                      fontSize="13px"
                                    >
                                      系统消息
                                    </Text>
                                    <Text fontSize="13px" display={"inline"}>
                                      {item.title}
                                    </Text>
                                  </Box>
                                  <Box
                                    mt="10px"
                                    color={"#8E94A9"}
                                    fontSize="10px"
                                  >
                                    {format(
                                      new Date(item.createat),
                                      "yyyy/MM/dd"
                                    )}
                                  </Box>
                                </Box>
                              </Flex>
                              {!item.is_read && (
                                <Box
                                  bg="#EA0000"
                                  mt="10px"
                                  w="6px"
                                  h="6px"
                                  borderRadius="6px"
                                ></Box>
                              )}
                            </Flex>
                          );
                        })}
                    </TabPanel>
                    {/* 私信 */}
                    <TabPanel pl="0" pr="0">
                      {!privateLetter?.length && (
                        <Flex
                          minH={"160px"}
                          flexDir={"column"}
                          justifyContent={"center"}
                          alignItems="center"
                        >
                          <Image src={noMessage} mb="14px" />
                          <Text fontSize={"14px"} color="#8E94A9">
                            没有未读的消息哦～
                          </Text>
                          {/* <Button onClick={()=> handleClickPrivateLetter("")}>
                        去聊天
                      </Button> */}
                        </Flex>
                      )}

                      {privateLetter &&
                        privateLetter.length > 0 &&
                        privateLetter.map((item, index) => {
                          return (
                            <Flex
                              p="10px"
                              key={index}
                              justifyContent="space-between"
                              _hover={{
                                bg: "rgba(238, 241, 247, 0.5)",
                              }}
                              onClick={() =>
                                handleClickPrivateLetter(item.form_id)
                              }
                            >
                              <Flex mr={"10px"} flex={1}>
                                <Avatar
                                  size="sm"
                                  mr="18px"
                                  src={`/api/v4/users/${item.from_user.id}/image`}
                                />
                                <Box>
                                  <Box
                                    mb="6px"
                                    fontWeight="700"
                                    color={"#27314D"}
                                    fontSize="13px"
                                  >
                                    {item.from_user.user_name}
                                  </Box>
                                  <Box fontSize="13px" display={"inline"}>
                                    {item.content}
                                  </Box>
                                  <Box
                                    mt="10px"
                                    color={"#8E94A9"}
                                    fontSize="10px"
                                  >
                                    {item.createat}
                                  </Box>
                                </Box>
                              </Flex>
                              <Box
                                bg="#EA0000"
                                mt="10px"
                                w="6px"
                                h="6px"
                                borderRadius="6px"
                              ></Box>
                            </Flex>
                          );
                        })}
                    </TabPanel>
                    {/* 新增关注 */}
                    <TabPanel pl="0" pr="0">
                      {!newFas?.length && (
                        <Flex
                          minH={"160px"}
                          flexDir={"column"}
                          justifyContent={"center"}
                          alignItems="center"
                        >
                          <Image src={noMessage} mb="14px" />
                          <Text fontSize={"14px"} color="#8E94A9">
                            没有未读的消息哦～
                          </Text>
                        </Flex>
                      )}

                      {newFas &&
                        newFas.length > 0 &&
                        newFas.map((item, index) => {
                          const hasFollowThisFan = followersList?.some(
                            (obj) => obj.user_id === item.user_id
                          );
                          return (
                            <Flex
                              p="10px"
                              key={index}
                              justifyContent="space-between"
                              _hover={{
                                bg: "rgba(238, 241, 247, 0.5)",
                              }}
                            >
                              <Flex mr={"10px"} flex={1}>
                                <Avatar
                                  size="sm"
                                  mr="18px"
                                  src={`/api/v4/users/${item.user_id}/image`}
                                />
                                <Box>
                                  <Box
                                    mb="6px"
                                    fontWeight="700"
                                    color={"#27314D"}
                                    fontSize="13px"
                                  >
                                    {item.user.username}
                                  </Box>
                                  <Box fontSize="13px" display={"inline"}>
                                    开始关注了你
                                  </Box>
                                  <Box
                                    mt="10px"
                                    color={"#8E94A9"}
                                    fontSize="10px"
                                  >
                                    {item.create_at}
                                  </Box>
                                </Box>
                              </Flex>
                              {!hasFollowThisFan && (
                                <Button
                                  borderRadius={"40px"}
                                  width={"80px"}
                                  height={"33px"}
                                  color="#FFFFFF"
                                  bgColor="#496AE1"
                                  border={"none"}
                                  fontSize="12px"
                                  _hover={{
                                    color: "##E6E6E6",
                                    bgColor: "#3F5BC1",
                                    border: "1px solid #8E94A9",
                                  }}
                                  onClick={() => handleCreateFollow(item)}
                                >
                                  回关
                                </Button>
                              )}

                              {hasFollowThisFan && (
                                <Button
                                  borderRadius={"40px"}
                                  width={"80px"}
                                  height={"33px"}
                                  color="#27314D"
                                  bgColor="#fff"
                                  border={"1px solid #8E94A9"}
                                  fontSize="12px"
                                  _hover={{
                                    color: "#27314D",
                                    bgColor: "#CBD1DF",
                                    border: "1px solid #8E94A9",
                                  }}
                                  onClick={() => handleCancelFollow(item)}
                                >
                                  已关注
                                </Button>
                              )}
                            </Flex>
                          );
                        })}
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Box>

              <Flex justifyContent={"space-around"} mr={"30px"}>
                {tabIndex === 0 && (
                  <Button
                    w="64px"
                    fontSize={"14px"}
                    color={"#8E94A9"}
                    fontWeight="normal"
                    variant="unstyled"
                    onClick={handleAllReadMsSystem}
                  >
                    全部已读
                  </Button>
                )}

                <Button
                  w="64px"
                  fontSize={"14px"}
                  fontWeight="normal"
                  color={"#8E94A9"}
                  variant="unstyled"
                  ml={"20px"}
                  onClick={handleGoMessagesCenter}
                >
                  查看全部消息
                </Button>
              </Flex>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
      <PrivateLetterModal
        isOpen={prvLetterControl.isOpen}
        onClose={prvLetterControl.onClose}
        curUserId={currentLetterUserId}
      />
    </>
  );
};

export default MessageMenu;
